const searchBarInit = () => {
  const header = document.querySelector('.header');
  const searchBar = header.querySelector('.header__searchbar');
  const searchIcon = header.querySelector('.header__searchicon');

  const headerSearchBarActive = 'header--searchbar';
  const searchBarActive = 'header__searchbar--active';
  const searchIconActive = 'header__searchicon--active';

  searchIcon.addEventListener('click', () => {
    header.classList.toggle(headerSearchBarActive);
    searchBar.classList.toggle(searchBarActive);

    searchIcon.classList.toggle(searchIconActive);
  });
};

export default searchBarInit;
